module.exports = new __parcel__URL__("image.ad72f679.svg").toString();